<template>
  <div>
    <div class="header-bg">
      <div class="header">
        <div class="h-l">
          <h1 @click="$router.push('/')" style="cursor: pointer;">
            <img src="../assets/images/logo.png" alt />
          </h1>
          <el-menu
            :default-active="tabIndex"
            class="el-menu-cdn"
            mode="horizontal"
            router
            active-text-color="#3EBBFF"
            text-color="#ffffff"
          >
            <el-menu-item index="/product">
              产品
              <ul class="menu_list">
                <li @click.stop="goTo('/product')" :class="{activeClass: curRouter === '/product'}">
                  抗D盾
                  <span>(DDoS防御)</span>
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/product/ccWorry')" :class="{activeClass: curRouter === '/product/ccWorry'}">
                  CC无忧
                  <span>(CC防御)</span>
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/product/xShield')" :class="{activeClass: curRouter === '/product/xShield'}">
                  X盾
                  <span>(Web应用防火墙)</span>
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/product/xunDispense')" :class="{activeClass: curRouter === '/product/xunDispense'}">
                  讯分发
                  <span>(CDN)</span>
                </li>
                <li @click.stop="goTo('/product/sslCertificate')" :class="{activeClass: curRouter === '/product/sslCertificate'}">
                  SSL证书
                  <b class="hot">HOT</b>
                </li>
                <!-- <li @click.stop="goTo('/product/woolShield')">
                  牧羊犬
                  <span>(羊毛盾)</span>
                </li>
                <li @click.stop="goTo('/product/baiControl')">佰监控</li>
                <li @click.stop="goTo('/product/xunPlatform')">讯平台</li>-->
              </ul>
            </el-menu-item>
            <el-menu-item index="/solution">
              解决方案
              <ul class="menu_list">
                <li @click.stop="goTo('/solution')" :class="{activeClass: curRouter === '/solution'}">
                  讯金盾
                  <b class="new">NEW</b>
                </li>
                <li @click.stop="goTo('/solution/gameSolution')" :class="{activeClass: curRouter === '/solution/gameSolution'}">
                  讯游盾
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/solution/broadcastSolution')" :class="{activeClass: curRouter === '/solution/broadcastSolution'}">
                  讯播盾
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/solution/shopSolution')" :class="{activeClass: curRouter === '/solution/shopSolution'}">讯商盾</li>
                <li @click.stop="goTo('/solution/educationSolution')" :class="{activeClass: curRouter === '/solution/educationSolution'}">讯学盾</li>
                <li @click.stop="goTo('/solution/newsSolution')" :class="{activeClass: curRouter === '/solution/newsSolution'}">
                  讯舆盾
                  <b class="hot">HOT</b>
                </li>
              </ul>
            </el-menu-item>
            <el-menu-item index="/intimateServer">
              贴心服务
              <ul class="menu_list">
                <li @click.stop="goTo('/intimateServer/equalInsurance2')" :class="{activeClass: curRouter === '/intimateServer/equalInsurance2'}">
                  等保2.0测评顾问
                  <b class="new">NEW</b>
                </li>
                <li @click.stop="goTo('/intimateServer/simulatedAttackAndDefense')" :class="{activeClass: curRouter === '/intimateServer/simulatedAttackAndDefense'}">
                  模拟攻防
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/intimateServer/codeAudit')" :class="{activeClass: curRouter === '/intimateServer/codeAudit'}">
                  代码审计
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/intimateServer/holeCheck')" :class="{activeClass: curRouter === '/intimateServer/holeCheck'}">漏洞排查</li>
                <li @click.stop="goTo('/intimateServer/rescue')" :class="{activeClass: curRouter === '/intimateServer/rescue'}">7*24小时救援</li>
                <li @click.stop="goTo('/intimateServer/safetyVerification')" :class="{activeClass: curRouter === '/intimateServer/safetyVerification'}">
                  安全验证
                  <b class="hot">HOT</b>
                </li>
              </ul>
            </el-menu-item>
            <!-- <el-menu-item index="/complianceSupport">
              合规支持
              <ul class="menu_list">
                <li @click.stop="goTo('/solution/live')">
                  信息安全保护培训
                  <b class="new">NEW</b>
                </li>
                <li @click.stop="goTo('/solution/boardGames')">
                  舆论监控平台
                  <b class="hot">HOT</b>
                </li>
                <li @click.stop="goTo('/solution/electronicBusiness')">
                  企业信息安全排查
                  <b class="hot">HOT</b>
                </li>
              </ul>
            </el-menu-item>-->
            <el-menu-item index="/customerService">服务客户</el-menu-item>
            <!-- <el-menu-item index="/simulationDemonstration">模拟演示</el-menu-item> -->
            <!-- <el-menu-item index="/aboutUs">
              模拟演示
              <div class="menu_list">
                <div class="alone_li">报表功能演示</div>
                <div class="alone_li">域名接入向导</div>
                <div class="alone_li" @click.stop="goTo('/guide/report')">游戏高防报表演示</div>
                <div class="alone_li">游戏高防接入向导</div>
              </div>
            </el-menu-item>-->
            <el-menu-item index="/aboutUs">
              关于佰讯
              <ul class="menu_list">
                <li @click.stop="goTo('/aboutUs')" :class="{activeClass: curRouter === '/aboutUs'}">公司介绍</li>
                <li @click.stop="goTo('/aboutUs/companyHonor')" :class="{activeClass: curRouter === '/aboutUs/companyHonor'}">荣誉资质</li>
                <li @click.stop="goTo('/aboutUs/news')" :class="{activeClass: curRouter === '/aboutUs/news'}">新闻中心</li>
              </ul>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="h-r">
          <a href="https://manage.sheyy.co/login" target="_blank">登录</a>
          <a class="btn-register" href="https://manage.sheyy.co/regist" target="_blank">免费注册</a>
        </div>
      </div>
    </div>
    <ul class="customer-service-ul">
      <li>
        <a class="customer-service">
          <div class="phone"></div>
          <div class="text">18571551951</div>
        </a>
      </li>
      <li>
        <a
          class="customer-service"
          target="_blank"
          href="http://wpa.qq.com/msgrd?v=3&uin=2224219189&site=qq&menu=yes"
        >
          <div class="qq"></div>
          <div class="text">2224219189</div>
        </a>
      </li>
      <!-- <li>
        <div class="customer-service">
          <span>
            意见
            <br />反馈
          </span>
        </div>
      </li>-->
    </ul>
  </div>
</template>

<script>
export default {
  name: "officialHead",
  data() {
    return {
      curRouter: ""
    };
  },
  watch: {
    $route(newVal) {
      // console.log(newVal.path)
      this.curRouter = newVal.path;
    }
  },
  computed: {
    tabIndex() {
      return "/" + this.$route.path.split("/")[1];
    }
  },
  methods: {
    goTo(item) {
      this.$router.push(item);
    }
  }
};
</script>

<style>
.menu_list {
  display: none;
}
.el-menu-item.is-active {
  border-bottom: 2px solid #3ebbff;
}
.el-menu-cdn .el-menu-item {
  font-size: 16px;
  position: relative;
}
.el-menu-cdn .el-menu-item:hover .menu_list {
  display: flex;
}
</style>
<style lang="scss" scoped>
.customer-service-ul {
  position: fixed;
  top: 30%;
  right: 0;
  z-index: 99;
  li {
    padding: 2px 10px;
    display: flex;
    justify-content: flex-end;
  }
}
.customer-service .phone {
  height: 54px;
  width: 54px;
  background: url("../assets/images/bottom/phone_btn_bg.png") no-repeat center;
  background-size: 23px 37px;
}
.customer-service .qq {
  height: 54px;
  width: 54px;
  background: url("../assets/images/bottom/qq_btn_bg.png") no-repeat center;
  background-size: 18px 35px;
}
.customer-service .text {
  height: 54px;
  width: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  transition: width 0.3s ease;
}
.customer-service:hover .text {
  width: 120px;
}
.customer-service {
  display: flex;
  cursor: pointer;
  background: #00a896;
  // width: 54px;
  border-radius: 2px;
  height: 54px;
}
.customer-service span {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  height: 54px;
  width: 54px;
}
.menu_list {
  position: absolute;
  left: 0;
  font-family: "微软雅黑";
  box-sizing: border-box;
  flex-direction: column;
  padding: 22px 20px;
  background: #363c4b;
  .alone_li {
    font-size: 15px;
    color: #aaa;
    &:hover {
      color: #3ebbff;
    }
  }
  .menu_list_title {
    font-size: 16px;
    color: #efefef;
    &:hover {
      color: #efefef;
    }
  }
  li {
    color: #aaa;
    font-size: 14px;
    text-align: start;
    line-height: 32px;
    span {
      color: #777;
    }
    &:hover {
      color: #3ebbff;
      span {
        color: #3ebbff;
      }
    }
  }
  .activeClass {
    color: #3ebbff;
    span {
      color: #3ebbff;
    }
  }
}
.header-bg.color-bg {
  background: #262b39;
}
.header-bg {
  width: 100%;
  position: fixed;
  background: #363c4b;
  top: 0;
  // left: 50%;
  z-index: 999;
  // transform: translateX(-50%);
  // -webkit-transform: translateX(-50%);
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  max-width: 1280px;
  height: 100%;
  margin: 0 auto;
}
.h-l {
  display: flex;
  align-items: center;
  ul {
    // height: 100%;
  }
  img {
    display: block;
  }
}
.h-r {
  display: flex;
  align-items: center;
  a {
    margin: 0 15px;
  }
  .btn-register {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 106px;
    height: 60px;
    background-color: #00a896;
    color: #fff;
  }
  .btn-register:hover {
    opacity: 0.8;
  }
}
h1 {
  margin: 0 18px 0 0;
}
.new,
.hot {
  display: inline-block;
  vertical-align: middle;
  font-weight: bold;
  margin-left: 4px;
}
.new {
  color: #48b1f3;
}
.hot {
  color: #ff4d00;
}
</style>
